import script from "./DeviceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&setup=true&lang=js"

import "./DeviceInfo.vue?vue&type=style&index=0&id=51fda2de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51fda2de"]])

export default __exports__